import styled from 'styled-components'
import { theme } from '@provi/provi-components'

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 32px;
`

export const SectionTitle = styled.h3`
  font-family: 'Inter', 'Montserrat', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  color: #999999;
  margin: 0;
  height: 24px;
  display: flex;
  align-items: center;
`

export const InputGroup = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;

  ${theme.breakpoints.down('md')} {
    flex-direction: column;
    width: 100%;
  }
`

export const CurrencyInput = styled.input`
  width: 320px;
  height: 40px;
  padding: 8px 16px;
  font-family: 'Inter', 'Montserrat', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #262626;
  background: white;
  border: ${({ $hasError }) => ($hasError ? '2px solid #AD1F22' : '1px solid #CCCCCC')};
  border-radius: 6px;
  outline: none;
  transition: border-color 0.2s;

  &:focus {
    border-color: ${({ $hasError }) => ($hasError ? '#AD1F22' : '#0273FF')};
    border-width: ${({ $hasError }) => ($hasError ? '2px' : '1px')};
  }

  &::placeholder {
    color: #999999;
  }

  ${theme.breakpoints.down('md')} {
    width: 100%;
  }
`

export const InputHelper = styled.p`
  font-family: 'Inter', 'Montserrat', sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: normal;
  color: #999999;
  margin: 8px 0 0 0;
  max-width: 320px;

  ${theme.breakpoints.down('md')} {
    max-width: 100%;
  }
`

export const InputError = styled.p`
  font-family: 'Inter', 'Montserrat', sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: normal;
  color: #ad1f22;
  margin: 8px 0 0 0;
  max-width: 320px;

  ${theme.breakpoints.down('md')} {
    max-width: 100%;
  }
`

export const ButtonGroup = styled.div`
  display: flex;
  gap: 8px;

  ${theme.breakpoints.down('md')} {
    width: 100%;
  }
`

export const SaveButton = styled.button`
  height: 40px;
  padding: 8px 16px;
  font-family: 'Inter', 'Montserrat', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: white;
  background: #0273ff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background: #0052cc;
  }

  &:active {
    background: #083cbc;
  }

  &:disabled {
    background: #cccccc;
    cursor: not-allowed;
  }

  ${theme.breakpoints.down('md')} {
    flex: 1;
  }
`

export const CancelButton = styled.button`
  height: 40px;
  padding: 8px 16px;
  font-family: 'Inter', 'Montserrat', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: #666666;
  background: white;
  border: 1px solid #cccccc;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    border-color: #999999;
    color: #333333;
  }

  &:active {
    background: #f7f7f7;
  }

  ${theme.breakpoints.down('md')} {
    flex: 1;
  }
`

export const DueDate = styled.div`
  font-family: 'Inter', 'Montserrat', sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 24px;
  color: #999999;
  margin: 0;
`
